var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    ref: "searchForm",
    attrs: {
      inline: true,
      size: "small",
      model: _vm.searchForm
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: null
    }
  }, [_vm._v("全部")]), _c("el-radio-button", {
    attrs: {
      label: "0"
    }
  }, [_vm._v("待调解 "), _vm.disputeStatus["0"] > 0 ? _c("span", {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.disputeStatus["0"]))]) : _vm._e()]), _c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("调解中 "), _vm.disputeStatus["1"] > 0 ? _c("span", {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.disputeStatus["1"]))]) : _vm._e()]), _c("el-radio-button", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("已调解 "), _vm.disputeStatus["2"] > 0 ? _c("span", {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.disputeStatus["2"]))]) : _vm._e()])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "纠纷编号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.disputeCode,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "disputeCode", $$v);
      },
      expression: "searchForm.disputeCode"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "签约编号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.contractCode,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "contractCode", $$v);
      },
      expression: "searchForm.contractCode"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "用户名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "userName", $$v);
      },
      expression: "searchForm.userName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.userPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "userPhone", $$v);
      },
      expression: "searchForm.userPhone"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: _vm.resetSearch
    }
  }, [_vm._v("重置")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "disputeCode",
      label: "编号",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "tenantInfo",
      label: "租客",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var tenantInfo = _ref.row.tenantInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: tenantInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "tenant.phone",
      label: "租客手机号",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "landlordInfo",
      label: "房东",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var landlordInfo = _ref2.row.landlordInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: landlordInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "contractCode",
      label: "签约编号",
      width: "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var row = _ref3.row;
        return [_c("router-link", {
          attrs: {
            to: "/capital/sign?contractCode=".concat(row.contractCode),
            target: "_blank",
            type: "primary"
          }
        }, [_c("el-link", {
          attrs: {
            type: "primary"
          }
        }, [_vm._v(_vm._s(row.contractCode))])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "status",
      width: "200",
      label: "申请状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var row = _ref4.row;
        return [row.status == 0 ? _c("el-tag", {
          attrs: {
            type: "danger",
            size: "small"
          }
        }, [_vm._v("待调解")]) : _vm._e(), row.status == 1 ? _c("el-tag", {
          attrs: {
            type: "info",
            size: "small"
          }
        }, [_vm._v("调解中")]) : _vm._e(), row.status == 2 ? _c("el-tag", {
          attrs: {
            type: "success",
            size: "small"
          }
        }, [_vm._v("已调解")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "description",
      width: "300",
      label: "纠纷描述"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "attachment",
      width: "150",
      label: "补充材料"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var row = _ref5.row;
        return _vm._l(row.attachment, function (item, index) {
          return _c("wlc-image", {
            key: item,
            attrs: {
              src: item,
              current: index,
              list: row.attachment,
              width: "50",
              compression: true
            }
          });
        });
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "adminName",
      width: "140",
      label: "处理人"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "operation",
      width: "140",
      label: "操作说明"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "processCreds",
      width: "150",
      label: "处理凭证"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var row = _ref6.row;
        return _vm._l(row.processCreds, function (item, index) {
          return _c("wlc-image", {
            key: item,
            attrs: {
              src: item,
              current: index,
              list: row.processCreds,
              width: "50",
              compression: true
            }
          });
        });
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "checkInTime",
      width: "140",
      label: "入住时间"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "applyTime",
      width: "160",
      label: "申请时间"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "processTime",
      width: "160",
      label: "处理时间"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "service_fee",
      width: "160",
      label: "操作",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-popconfirm", {
          key: scope.row.id,
          attrs: {
            placement: "top-end",
            title: "确认认领？",
            trigger: "hover"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.disputeClaim(scope.row);
            }
          }
        }, [scope.row.status == 0 ? _c("el-button", {
          staticClass: "wlc-button-warning",
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            slot: "reference",
            type: "text",
            size: "mini"
          },
          slot: "reference"
        }, [_vm._v(" 认领 ")]) : _vm._e()], 1), _c("el-popconfirm", {
          key: scope.row.id,
          attrs: {
            placement: "top-end",
            title: "确认已完成纠纷处理？",
            trigger: "hover"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.disputeProcessed(scope.row);
            }
          }
        }, [scope.row.status == 1 ? _c("el-button", {
          staticClass: "wlc-button-succes",
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            slot: "reference",
            type: "text",
            size: "mini"
          },
          slot: "reference"
        }, [_vm._v(" 标记已处理 ")]) : _vm._e()], 1), scope.row.status != 0 ? _c("el-button", {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.operationDescDialog(scope.row);
            }
          }
        }, [_vm._v("操作说明")]) : _vm._e()];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.pageSize,
      "current-page": _vm.searchForm.pageNum,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "操作说明",
      width: "400px",
      visible: _vm.operationDescDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.operationDescDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "操作说明",
      "label-width": "80px"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.operationForm.operation,
      callback: function callback($$v) {
        _vm.$set(_vm.operationForm, "operation", $$v);
      },
      expression: "operationForm.operation"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "处理凭证",
      "label-width": "80px"
    }
  }, [_c("SchematicImg", {
    attrs: {
      max: 8
    },
    model: {
      value: _vm.operationForm.processCreds,
      callback: function callback($$v) {
        _vm.$set(_vm.operationForm, "processCreds", $$v);
      },
      expression: "operationForm.processCreds"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      loading: _vm.operationLoading,
      type: "primary"
    },
    on: {
      click: _vm.updateOperation
    }
  }, [_vm._v(" 确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };